// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c798a6a5","977":"46bc1f65"}[chunkId] + ".chunk.js";
};